module.exports = __webpack_public_path__ + "assets/img/return-1dab830b.png";